export default __webpack_public_path__ + "static/media/ic_fusd_40.3e0958e2.svg";